module.exports = "/build/admin/images/ajax-loader.84124e0a.gif";